import { MOBILE_TABS, type MobileTab } from './MobileTabBar';

// ─────────────────────────────────────────────────────────────────────
// WHICH TAB A LINK OPENS (#1137).
//
// The pay-link mail sends a member to `…?native=1&club=<slug>&tab=reservations
// #mobile`, so they land on «Reservasjoner», where «Betal nå» is, rather than
// on «Hjem» with nothing to say where to go. Read from the address once, when
// the app mounts — the same moment `initialTab` is read.
//
// An ALLOW-LIST of the tabs the app has. Anything else — a typo, a tab that
// was renamed, a value somebody made up — is ignored and the app opens on its
// ordinary default, never on a blank screen.
// ─────────────────────────────────────────────────────────────────────

const TABS = new Set<string>(MOBILE_TABS.map((t) => t.id));

export function initialMobileTabFromLocation(
  search: string = typeof window === 'undefined' ? '' : window.location.search,
): MobileTab | undefined {
  try {
    const tab = new URLSearchParams(search).get('tab');
    return tab !== null && TABS.has(tab) ? (tab as MobileTab) : undefined;
  } catch {
    return undefined;
  }
}
